<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage type="add" isEdit />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import baseMessage from './components/baseMessage.vue'
</script>
<script lang="ts">
export default { name: 'DcCosLbuSaleCoachingAdd' }
</script>
